<template>
  <div class="ah-product-card">
      <div class="ah-product-card-inner">
          <card-header :image="image" :species="species" :heading="heading" :links="links" :isMaterial="isMaterial" />
          <card-body :category="category" :heading="heading" :excerpt="excerpt" />
          <card-footer :links="links" />
      </div>
  </div>
</template>

<script>
  import CardHeader from './CardHeader/CardHeader.vue'
  import CardBody from './CardBody.vue'
  import CardFooter from './CardFooter.vue'

  export default {
    name: 'product-card',
    props: {
      image: Object,
      species: Array,
      category: String,
      heading: String,
      excerpt: String,
      links: Array,
      isMaterial: Boolean
    },
    components: {
      CardHeader,
      CardBody,
      CardFooter,
    },
  }
</script>

<style scoped lang="scss">
  .ah-product-card {
    margin: 15px 0;
  }

  .ah-product-card-inner {
    display: flex;
    flex-direction: column;
    /*width: 308px;*/
    box-shadow: 2px 2px 14px 0 rgba(0,35,74,0.1);
    border-radius: 5px;
    height: 100%; 
    margin: 0;
  }
</style>
